/* StringDiffUtil.js */

"use strict";
let diff_match_patch = require("diff-match-patch");

class StringDiffUtil {
    static getDiff(text1, text2) {
        let dmp = new diff_match_patch();
        let diff = dmp.diff_main(text1, text2);
        dmp.diff_cleanupSemantic(diff);
        // console.log("Diff of updates: " + JSON.stringify(diff));
        return diff;
    }
}

module.exports = StringDiffUtil;
